"use strict";

_theme.Customer = (function(){
    var selectors = {
        loginForm: '[data-login-form]',
        registerForm: '[data-register-form]',
        forgotPasswordForm: '[data-forgot-password-form]',
        resetPasswordForm: '[data-password-reset-form]',
        activatePasswordForm: '[data-activate-account-form]'
    };

    function Customer(){
        this.initTogglePassword();

        var loginForm = document.querySelector(selectors.loginForm);
        loginForm && this.initLoginForm();

        var registerForm = document.querySelector(selectors.registerForm);
        registerForm && this.initRegisterForm();

        var forgotPasswordForm = document.querySelector(selectors.forgotPasswordForm);
        forgotPasswordForm && this.initForgotPasswordForm();

        var resetPasswordForm = document.querySelector(selectors.resetPasswordForm);
        var activatePasswordForm = document.querySelector(selectors.activatePasswordForm);
        (resetPasswordForm || activatePasswordForm) && this.initResetPasswordForm();
    }

    Customer.prototype.initTogglePassword = function(){
        var icon_eye = document.querySelectorAll('.icon-eye');
        if(icon_eye && icon_eye.length){
            icon_eye.forEach(function(icon){
                icon.addEventListener('click', function(evt){
                    const input = evt.currentTarget.parentElement.querySelector('input');
                    input.type = input.type === 'password' ? 'text' : 'password';
                });
            });
        }
    }
    Customer.prototype.initLoginForm = function(){
        var fields=[{id:"#CustomerEmail",name:"customer[email]",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:"This field is required",condition:"Invalid email address"}},{id:"#CustomerPassword",name:"customer[password]",optional:!1,depend:null,error:{empty:"This field is required",condition:"This field is required"}}];
        this.LoginFormObj = new _theme.InitForm(selectors.loginForm, fields);
    }
    Customer.prototype.initRegisterForm = function(){
        var fields=[{id:"#RegisterForm-FirstName",name:"customer[first_name]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:`This field is required`,condition:"The first name must contain at least 3 characters"}},{id:"#RegisterForm-LastName",name:"customer[last_name]",optional:!1,regex:/(?=.{1,})/,depend:null,error:{empty:`This field is required`,condition:"The last name must contain at least 1 characters"}},{id:"#RegisterForm-email",name:"customer[email]",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:`This field is required`,condition:"Invalid email address"}},{id:"#RegisterForm-password",name:"customer[password]",optional:!1,regex:/(?=.{8,})/,depend:null,error:{empty:`This field is required`,condition:"Password should be 8 character or long"}},{id:"#RegisterForm-confirm-password",name:"customer[confirm_password]",optional:!1,regex:null,depend:{id:"#RegisterForm-password",optional:!1,regex:/(?=.{8,})/,matchValue:!0,error:{empty:`This field is required`,condition:"Password should be 8 character or long"}},error:{empty:`This field is required`,condition:"The passwords are not identical"}}];
        this.RegisterFormObj = new _theme.InitForm(selectors.registerForm, fields);
    }
    Customer.prototype.initForgotPasswordForm = function(){
        var fields=[{id:"#RecoverEmail",name:"email",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:"This field is required",condition:"Invalid email address"}}];
        this.ForgotPasswordFormObj = new _theme.InitForm(selectors.forgotPasswordForm, fields);
    }
    Customer.prototype.initResetPasswordForm = function(){
        var fields=[{id:"#password",name:"customer[password]",optional:!1,regex:/(?=.{8,})/,depend:null,error:{empty:"This field is required",condition:"Password should be 8 character or long"}},{id:"#password_confirmation",name:"customer[password_confirmation]",optional:!1,depend:{id:"#password",optional:!1,regex:/(?=.{8,})/,matchValue:!0,error:{empty:"This field is required",condition:"Password should be 8 character or long"}},error:{empty:"This field is required",condition:"The passwords are not identical"}}];
        this.ResetPasswordFormObj = new _theme.InitForm(selectors.resetPasswordForm, fields);
    }
    return Customer;
})();
window.addEventListener('DOMContentLoaded', function(event){
  var icon_eye = document.querySelectorAll('.icon-eye');
  if(icon_eye && icon_eye.length){
    icon_eye.forEach(function(icon){
      icon.addEventListener('click', function(evt){
        const input = evt.currentTarget.parentElement.querySelector('input');
        input.type = input.type === 'password' ? 'text' : 'password';
      });
    });
  }
});

const ButtonElement = ['signin-btn', 'create-btn', 'submit-btn'];
document.addEventListener('click', function(event){
  if(ButtonElement.includes(event.target.classList.value)) {
    event.preventDefault();
    setTimeout(function(){
      event.target.click();
      new _theme.Customer();
    }, 200);
  }
});